import { get } from '@/services/get'
import { Applicant } from '@/types/application/applicant'

export function getApplicationsApplicant(applicationId: string) {
  return get<Applicant>(`/applications/${applicationId}/applicant`)
}
